<template>
  <div class="module-container">
    <DD
      :absolute="true"
      :title="$parent.data.acf_fc_layout"
      v-if="$parent.data && moduleDebug"
      >{{ $parent.data }}</DD
    >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "module-container"
};
</script>
